@if (incomeTaxEntity$ | async) {
<form [formGroup]="formGroup">
    @if (dieten.length > 0) {
      <div formArrayName="dieten">
        @for (item of dieten.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-select-form-control
              [label]="i === 0 ? 'Aandoening en dieettypering' : ''"
              [options]="aandoeningen"
              class="col-auto custom-input-250"
              formControlName="aandoening"
              label="Aandoening"
            >
            </snelstart-ui-select-form-control>
            <div class="row col-auto" formGroupName="periode">
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Begindatum' : ''"
                                              class="col-auto custom-input-150"
                                              formControlName="begindatum"
                                              [placeholder]="'dd-mm-' + (incomeTaxEntity$ | async)?.year"
                                              id="begindatum"
              >
              </snelstart-ui-date-form-control>
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Einddatum' : ''"
                                              class="col-auto custom-input-150"
                                              formControlName="einddatum"
                                              [placeholder]="'dd-mm-' + (incomeTaxEntity$ | async)?.year"
                                              id="einddatum"
              >
              </snelstart-ui-date-form-control>
            </div>
            <div class="row col-auto">
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                   icon="trash"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary">
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus"
                       type="link">Dieetkosten
  </snelstart-ui-button>
}


